import Loadable from "react-loadable";

const AsyncArtistShopPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "artist-shop-page" */ "./AsyncArtistShopPageRoute"
    ),
  loading: () => null,
});

export default AsyncArtistShopPage;
